module.exports = __webpack_public_path__ + "static/img/pic2.7ca304f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example01/pic2.png
// module id = e7SU
// module chunks = 1